<template>
  <button
    v-if="visible"
    class="ai-assistant-btn"
    :title="$t('aiAssistant.title')"
    :aria-label="$t('aiAssistant.title')"
    @click="toggle"
  >
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l1.8 4.5L18 8.3l-4.5 1.8L12 14.5l-1.8-4.4L6 8.3l4.2-1.8L12 2z" />
      <path d="M18.5 15l.9 2.2 2.2.9-2.2.9L18.5 21l-.9-2L15.4 18l2.2-.8.9-2.2z" opacity=".7" />
    </svg>
  </button>
</template>

<script>
export default {
  name: "AiAssistantButton",
  computed: {
    visible() {
      return Boolean(import.meta.env.VITE_KHABEER_AI_URL);
    },
  },
  methods: {
    toggle() {
      this.$store.commit("aiAssistant/toggle");
    },
  },
};
</script>

<style scoped>
.ai-assistant-btn {
  position: fixed;
  bottom: 20px;
  inset-inline-end: 20px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(99, 102, 241, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.ai-assistant-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 20px rgba(99, 102, 241, 0.5);
}
.ai-assistant-btn:active {
  transform: scale(0.98);
}
</style>
